<app-total [total]="cart.totalCost" [totalDiscount]="cart.totalDiscount" [totalRaw]="cart.totalRaw" [quantity]="cart.totalItems" [freq]="cart.paymentFrequency" (click)="open()"></app-total>
